export const version = "abstract-signer/5.0.13";
//# sourceMappingURL=_version.js.map